import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild
} from "@angular/core";

import { Router } from "@angular/router";
import * as momentTz from "moment-timezone";
import { FramesService } from "../../../routes/services/frames.service";
import { GlobalFunction } from "../../../routes/services/globalFuntion";
import { NgbModal, NgbPopoverConfig } from "@ng-bootstrap/ng-bootstrap";
import { Subscription } from "rxjs";
import { preferenceChecks, StorageService } from "../../../routes/services/storage.service";
import { sensors } from "../../../routes/Clients/device/constants";
import { MinMaxService } from "../../config_sensors_device/min_max/services/min_max.service";

@Component({
  selector: "app-sensors-value",
  templateUrl: "./sensors_value.html",
  styleUrls: ["./sensors_value.scss"],
  providers: [NgbPopoverConfig]
})
export class SensorsValueComponent implements OnInit {
  /* MODIFICAR MODULO CON LA CONSTANTE DE alerts_waterwise */

  @Input() data;
  @Input() type;
  @Input() header: boolean = false;
  @Input() footer: boolean = false;
  @Input() permissions = {
    view_feedingfuzzylogic: true
  };

  @Output("submit") submit = new EventEmitter();
  @ViewChild("modalconfigSensed") modalconfigSensed;

  @Input() enabled = false;
  @Input() view_sensors = true;
  @Input() view_sensors_hydro = true;

  loading_data: "done" | "loading" | "error" | "" = "";

  socketSubsciption: Subscription;

  sensors = sensors;
  viewModalTestDevice = false;

  colors = {
    low_success: "#B6D7A8",
    high_success: "#009e0f",
    low_danger: "#EA9999",
    high_danger: "#CF2A27",
    low_warning: "#F1C232",
    high_warning: "#FF9900",
    default_color: "#204349",
    white: "#ffffff"
  };
  @Input() checks_parametry_preference: preferenceChecks = {
    TEM: true,
    PTEM: true,
    HUM: true,
    DO: true,
    EC: true,
    SAT: true,
    SG: true,
    SAL: true,
    TDS: true,
    PH: true,
    ORP: true,
    PRESSURE: true
  };

  constructor(
    public Router: Router,
    public framesService: FramesService,
    public globalFunction: GlobalFunction,
    public modalService: NgbModal,
    config: NgbPopoverConfig,
    public storageService: StorageService,
    public minMaxService: MinMaxService
  ) {
    config.container = "body";
    config.placement = "auto";
    config.popoverClass = "border-pop";
  }
  ngOnInit(): void {
    const frames = [
      "WATERWISESENSORSSTATUS",
      "SENSOR_HYDRO_RESPONSE",
      "ALERT_Communication",
      "ALERT_COMM"
    ];
    this.socketSubsciption = this.storageService.watchStorage("socket").subscribe((msg: any) => {
      if (msg.data && frames.includes(msg.data.type)) {
        const set_value = () => {
          if (this.data) {
            let result = this.globalFunction.setDataFeeders([this.data], msg);
            const exist = result.feederChanged.find((item: any) => item.id === this.data.id);
            if (exist) {
              this.loading_data = "done";
              if (msg.data.type === "ALERT_Communication" || msg.data.type === "ALERT_COMM") {
                this.loading_data = "error";
              }
            }
          }
        };
        if (
          msg.data.type === "WATERWISESENSORSSTATUS" &&
          !Object.prototype.hasOwnProperty.call(msg.data, "sensor_enabled")
        ) {
          set_value();
        }
        if (msg.data.type !== "WATERWISESENSORSSTATUS") {
          set_value();
        }
      }
    });
  }
  validateColorMaintenance(value: number, type: "low" | "high"): string {
    if (value < 0 || value > 100) {
      throw new Error("El valor debe estar entre 0 y 100");
    }

    if (value <= 33) {
      return this.colors[`${type}_danger`];
    } else if (value <= 66) {
      return this.colors[`${type}_warning`];
    }
    return this.colors[`${type}_success`];
  }
  changeEnabledDisabled(value) {
    /* FUNCION PARA ACTIVAR Y DESACTIVAR SENSORES  */
    this.submit.emit({ type: "ENABLE_DISABLE_SENSORS", value });
  }
  validateError(resp) {
    if (resp && resp.errors) {
      this.globalFunction.animation("error", "Gateway desconectado", "Error");
    } else {
      this.globalFunction.animation("success", `Se solicitó correctamente`, "Ok");
    }
  }

  insertTimezone(prop) {
    if (this.type === "individual") {
      const { sensors, farm } = this.data;

      if (farm && farm.timezone && sensors) {
        // Utiliza el formato personalizado para analizar la fecha y hora
        const dateTime = momentTz(sensors[prop]).tz(farm.timezone);
        /* DD/MM/YYYY, :ss */
        const timeFormatted = dateTime.format("HH:mm");
        return timeFormatted;
      }
    }

    return "";
  }

  goSensors() {
    this.Router.navigateByUrl(`/granja/sensores/${1}/${this.data.id}`);
  }

  configModal = {
    backdrop: true,
    ignoreBackdropClick: false,
    keyboard: false,
    centered: true,
    size: "lg"
  };
  Modal = (template: TemplateRef<any>, type) => {
    switch (type) {
      case "show":
        this.modalService.open(template, this.configModal);
        break;
      case "hide":
        this.modalService.dismissAll(``);
        break;
      default:
    }
  };
  viewConfig() {
    this.Modal(this.modalconfigSensed, "show");
  }
  getTypeSensors(event) {
    const query = `?id_in=${this.data.id}`;

    if (event.type === "SENSORS") {
      this.framesService.FramePost("set_points", query, event.value).subscribe((resp) => {
        this.validateError(resp);
      });
    }
    if (event.type === "SENSORS_SET_POINTS") {
      this.framesService
        .FramePost("set_points_state", query, {
          set_point_enabled: event.value
        })
        .subscribe((resp) => {
          this.validateError(resp);
        });
    }
  }

  validateColorAlert(alert: "hum" | "water_temp" | "temp", value) {
    let obj = {
      warning: "#c29834",
      danger: "#cf2a27",
      succes: "#26af76"
    };

    if (this.data.sensors) {
      const sensors = this.data.sensors;
      const min = sensors[`alert_${alert}_min`];
      const max = sensors[`alert_${alert}_max`];
      const warning_value = Number(max - min) / 5;
      if (value && min && max) {
        const warning_min = min + warning_value;
        const warning_max = max - warning_value;
        if (value < min || value > max) {
          return obj.danger;
        }
        if ((value > min && value < warning_min) || (value < max && value > warning_max)) {
          return obj.warning;
        }
        if (value > min && value < max) {
          return obj.succes;
        }
      }
    }

    return obj.succes;
  }
  closePanel() {
    this.viewModalTestDevice = false;
  }
  changelfblock() {
    const block = this.data.fuzzy_logic ? "lf_block_on" : "lf_block_off";
    this.framesService.waterwiseMasiveFrames(block, `?id_in=${this.data.id}`).subscribe((resp) => {
      if (resp && resp.hasOwnProperty("errors")) {
        for (const key in resp.errors) {
          this.globalFunction.animation("error", "", resp.errors[key]);
        }
        this.data.fuzzy_logic = !this.data.fuzzy_logic;
      } else {
        this.globalFunction.animation(
          "success",
          "Recomendación de alimentacion",
          `${this.data.fuzzy_logic ? "Activada" : "Desactivada"} correctamente`
        );
      }
    });
  }

  validateColorImage(
    data,
    type: "battery" | "panel",
    success = this.colors.low_success,
    warning = this.colors.low_warning,
    danger = this.colors.low_danger
  ) {
    let { battery, panel } = data;

    if (type === "battery") {
      if (battery > 12.5) return success;
      if (battery > 11.5 && battery <= 12.5) return warning;
      if (battery <= 11.5) return danger;
    }
    if (type === "panel") {
      if (panel > 15) return success;
      if (panel > 12 && panel <= 15) return warning;
      if (panel <= 12) return danger;
    }

    return danger;
  }

  turOnOffWaterwise = () => {
    const type = this.data.power ? "turn_off" : "turn_on";
    this.framesService.waterwiseFrames(this.data.id, type).subscribe((resp) => {
      if (resp && !resp.errors) {
        this.data.power = !this.data.power;
      }
    });
  };

  resetAlertWaterwise = (prop: string, value) => {
    this.framesService.reset_alert_waterwise(this.data.id, { [prop]: value }).subscribe((resp) => {
      console.log(resp);
      this.globalFunction.animation(
        "success",
        "¡Enhorabuena!",
        "Se ha reiniciado alerta de mantenimiento"
      );
      this.data[prop] = value;
    });
  };
}
